module.exports = __webpack_public_path__ + "static/img/12.d5129a33.jpg";